import { LiveSessionListRouteParamIds } from '../live-session/live-session.routing.names';

export const SessionListRouteNames = {
  HOME: '',
  LIVE_SESSION: ':' + LiveSessionListRouteParamIds.SESSION_ID,
};
